'use strict';

var _ = require('lodash');
var PrepareItemsModalController = function PrepareItemsModalController($scope, configurationService, ScheduleChangeConstants, userSecureService, featureToggleService, directForecastingConfigurationService) {
  $scope.existingItemsOptions = [];
  $scope.showNew = true;
  $scope.MANAGE_ITEMS_NEW = 'items-new';
  $scope.MANAGE_ITEMS_EXISTING = 'items-existing';
  $scope.selectedItems = {};
  $scope.selectedItems[$scope.MANAGE_ITEMS_NEW] = '';
  $scope.selectedItems[$scope.MANAGE_ITEMS_EXISTING] = null;
  $scope.manageItems = $scope.MANAGE_ITEMS_NEW;
  $scope.newItemsPattern = '^([A-Z]{3}-[A-Z]{3})(,\\s*[A-Z]{3}-[A-Z]{3})*\\s*$';
  function enableNewItem(wizard) {
    if (wizard === 'markets') {
      return userSecureService.hasAuthorization('manage-market', 'write');
    } else {
      return userSecureService.hasAuthorization('manage-leg-flight', 'write');
    }
  }
  function setDefaultFieldValues() {
    $scope.manageItems = $scope.MANAGE_ITEMS_NEW;
    $scope.selectedItems[$scope.MANAGE_ITEMS_NEW] = '';
    $scope.selectedItems[$scope.MANAGE_ITEMS_EXISTING] = null;
  }
  function filterDirectForecastingMarkets(element) {
    if (featureToggleService.isDisabled('DIRECT_FORECAST_ENABLE') || !_.includes([ScheduleChangeConstants.ENTITIES.MARKETS], $scope.chosenWizard)) {
      return true;
    }
    return !directForecastingConfigurationService.isDirectForecastingMarket(element.origin, element.destination);
  }
  function getExistingItemsOptions() {
    var elems;
    var isSmlEnabled = featureToggleService.isEnabled('SML');
    if ($scope.chosenWizard === ScheduleChangeConstants.ENTITIES.MARKETS) {
      elems = isSmlEnabled ? configurationService.getMarkets() : configurationService.getNonCodeShareMarkets();
    } else {
      elems = isSmlEnabled ? configurationService.getLegs() : configurationService.getNonCodeShareLegs();
    }
    return _.chain(elems).filter(filterDirectForecastingMarkets).map(function (ele) {
      return ele.origin + '-' + ele.destination;
    }).uniq().sort().value();
  }
  $scope.$watch('manageItems', function (value) {
    if (value) {
      $scope.xtForm.reset();
    }
  });
  $scope.setChosenWizard = function (wizard) {
    if (wizard) {
      $scope.chosenWizard = wizard;
      $scope.existingItemsOptions = getExistingItemsOptions();
      $scope.enableNew = enableNewItem(wizard);
      $scope.texts = {
        modalTitle: 'Manage ' + _.capitalize(wizard),
        newItemsLabel: 'Prepare Revenue Optimizer for new ' + wizard.replace('s', '(s)'),
        newItemsPlaceholder: 'Enter New ' + _.capitalize(wizard) + ' Name e.g: AAA-BBB, CCC-DDD',
        existingItemsLabel: 'Manage existing ' + wizard.replace('s', '(s)'),
        existingItemsPlaceholder: 'Select ' + _.capitalize(wizard)
      };
      $scope.showNew = wizard !== ScheduleChangeConstants.ENTITIES.FLIGHTS;
      if (!$scope.showNew || !$scope.enableNew) {
        $scope.manageItems = $scope.MANAGE_ITEMS_EXISTING;
      }
    }
  };
  $scope.submitPreparedItems = function () {
    $scope.xtForm.submit();
    if ($scope.xtForm.form.$valid) {
      var items = $scope.selectedItems[$scope.manageItems];
      $scope.$emit('schedule-change:initWizard', $scope.chosenWizard, items);
      $scope.hideModal();
    }
  };
  $scope.cancelPreparedItems = function () {
    setDefaultFieldValues();
    $scope.xtForm.reset();
  };
  $scope.isNewItems = function () {
    return $scope.manageItems === $scope.MANAGE_ITEMS_NEW;
  };
  $scope.isExistingItems = function () {
    return $scope.manageItems === $scope.MANAGE_ITEMS_EXISTING;
  };
  setDefaultFieldValues();
};
PrepareItemsModalController.$inject = ['$scope', 'ConfigurationService', 'ScheduleChangeConstants', 'UserSecureService', 'FeatureToggleService', 'DirectForecastingConfigurationService'];
module.exports = PrepareItemsModalController;